import { useEffect, useMemo } from 'react';

import { jwtDecode } from 'jwt-decode';
import { useSearchParams } from 'react-router-dom';
import { useGetShareLinkData } from '@/core/api/queries';

const decodeShareData = (jwtToken: string) => {
  try {
    const { authToken, shareLinkId } = jwtDecode(jwtToken) as {
      authToken: string;
      shareLinkId: string;
    };
    return {
      authToken,
      shareLinkId,
    };
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};

export const useSharedShipmentData = (pollShipments: boolean = false) => {
  const [params] = useSearchParams();

  const linkData = params.get('data') || '';

  const { authToken, shareLinkId } = decodeShareData(linkData) as {
    authToken: string;
    shareLinkId: string;
  };

  const { data: shareLinkData, isLoading, isError, isFetching } = useGetShareLinkData(shareLinkId || '');

  useEffect(() => {
    if (authToken) localStorage.setItem('_jwt_fto_shared', authToken);
  }, [authToken]);

  // Extract data for easy access
  const shipments = useMemo(() => shareLinkData?.shipments ?? null, [shareLinkData?.shipments]);
  const fields = useMemo(() => shareLinkData?.fields ?? null, [shareLinkData?.fields]);

  const trackingJobsMap = useMemo(() => ({} as Record<string, any>), []);
  useEffect(() => {
    if (!pollShipments) return;

    const intervalId = setInterval(() => {
      shareLinkData?.refetch();
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    return () => {
      clearInterval(intervalId);
    };
  }, [pollShipments, shareLinkData?.refetch]);

  return {
    // Raw query objects (for refetch, etc.)
    queries: {
      shareLinkData,
    },

    shipments,
    fields,

    trackingJobsMap,

    isLoading,
    isError,
    isFetching,

    refetchAll: () => {
      shareLinkData.refetch();
    },
  };
};
